import { VueExtension } from '../../utils/extensions/vue';
import TabPane from './tabpane.jsx';
import './tabpane.scss';

VueExtension.WithInstall(TabPane);

export default TabPane;